import React from 'react';
import logo from '../../../../assets/Logo/logo.png';
import './FooterLogo.scss';

export const FooterLogo = () => {
  return <img className="FooterLogo" src={logo} alt="Get U There Logo" />;
};
